import { gql } from '@apollo/client';

export const UPDATE_MARKETING_EMAIL_PREFERENCE = gql`
    mutation UpdateMarketingEmailPreference($data: UpdateMarketingEmailPreferenceInput!) {
        updateMarketingEmailPreference(data: $data) {
            id
            email
            isSubscribedToMarketingEmails
            isSubscribedToNewsletter
        }
    }
`;

